<template>
  <DefaultIndex msg="Welcome to ModelRailroad.Live"/>
</template>

<script>
import DefaultIndex from './components/DefaultIndex.vue'

export default {
  name: 'App',
  components: {
    DefaultIndex
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
